import * as React from 'react';

/**
 * Makes a stable reference of the `trpc` prop
 */ function useHookResult(value) {
    const ref = React.useRef(value);
    ref.current.path = value.path;
    return ref.current;
}

export { useHookResult };
